import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const About = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-black via-gray-900 to-black overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg flex items-center justify-center shadow-lg shadow-purple-500/50">
                <div className="w-4 h-4 bg-white rounded-sm"></div>
              </div>
              <span className="text-purple-400 font-semibold uppercase tracking-wider text-sm">
                ABOUT US
              </span>
            </div>

            <h2
              className="text-4xl sm:text-5xl font-bold text-white leading-tight"
              style={{ letterSpacing: '0.08em' }}
            >
              Building Digital Experiences That Drive Growth
            </h2>

            <p className="text-lg text-gray-400 leading-relaxed">
              At Invotage, we don't just build digital products—we craft transformative experiences that propel businesses forward. Our team of industry experts combines innovation, technical excellence, and strategic thinking to deliver solutions that exceed expectations and drive real business value.
            </p>

            <Link to="/about">
              <Button className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-6 py-6 rounded-full group shadow-lg shadow-purple-500/50">
                Discover More About Us
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative z-10 rounded-3xl overflow-hidden shadow-2xl shadow-purple-900/50 border border-purple-500/20">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c"
                alt="Team collaboration"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gradient-to-br from-purple-600/30 to-blue-600/30 rounded-3xl -z-10 blur-xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;